<template lang="html">
  <v-app>
    <!-- <v-dialog
      v-model="profile_dialog"
      persistent
      :overlay="false"
      max-width="400px"
      max-height="300px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title class="headline">
          ข้อมูลส่วนตัว
        </v-card-title>
        <v-divider></v-divider>
        </v-card-title>
        <v-card-text style="height: 300px;">
          <v-layout row wrap justify-center align-center style="height: 300px;" v-if="progress">
            <v-progress-circular size="80" :indeterminate="progress" color="primary"></v-progress-circular>
          </v-layout>
          <v-layout row wrap justify-center align-start style="height: 300px;" v-else>
            <v-flex xs12 sm12 md12 xl12 lg12>
              <v-layout column wrap justify-center align-center>
                <v-avatar
                  size="80"
                >
                  <img v-if="profile_infor.profilepicture" :src="profile_infor.profilepicture" alt="">
                  <img v-else src="/static/img/default_profile/man-white.png" alt="" class="img-user">
                </v-avatar>
                <h3 class="mt-3">{{ profile_infor.name }}</h3>
                <h4 style="color: grey;" class="mt-2">{{ profile_infor.email }}</h4>
                <v-btn color="primary" outline round class="mt-5" @click="check_profile()">ไปที่ห้องแชท</v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog> -->
    <v-layout v-if="progress" row wrap justify-center align-center style="height: 100vh;">
      <v-progress-circular size="80" :indeterminate="progress" color="primary"></v-progress-circular>
    </v-layout>
  </v-app>
</template>

<script>
import { Decode, Encode } from '@/services'
export default {
  data () {
    return {
      windowWidth: '',
      progress: false,
      profile_dialog: false,
      profile_infor: {},
      tokenroom: '',
      tokenuser: '',
      status_username: ''
    }
  },
  created () {
    console.log(`created`)
    // this.profile_dialog = true
    // var tokenuser = Encode.encode('Uba7cb86c384f5fa5b3eae7269b4993ce')
    // console.log(tokenuser)
    // var tokenuser = '=%3DM0UuZXTkFmMyIjMmlTOzcjN3gTM4YmZjVjZkRmZ4MjZ3YmZiRWVgPm8SOZSzu'
    // console.log(window.location.href)
    this.windowWidth = window.innerWidth
    var url_string = window.location.href
    var url = new URL(url_string)
    this.tokenuser = url.searchParams.get('user_id')
    this.tokenroom = url.searchParams.get('room_id')
    this.status_username = url.searchParams.get('stateusername')
    console.log(`url: ${url.searchParams.get('logouturl')}`)
    this.$cookie.set('logouturl', url.searchParams.get('logouturl'))

    // this.tokenroom = this.tokenroom.replace(/['"]+/g, '')
    // this.tokenuser = this.tokenuser.replace(/['"]+/g, '')
    // this.status_username = this.status_username.replace(/['"]+/g, '')
    // console.log(this.tokenuser)
    // console.log(this.tokenroom)
    // console.log(this.tokenuser)
    // console.log(tokenuser)
    // console.log(Decode.decode(tokenuser))

    // var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    // var old_token = decoded['tokenuser']
    // console.log(old_token)
    // if (old_token !== undefined || old_token !== '' || old_token !== null) {
    //   this.$socket.emit('leave', {room: old_token, type: 'web'})
    //   localStorage.clear()
    // }
    this.get_user(Decode.decodeToken(this.tokenuser))
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        console.log(`mounted`)
        this.windowWidth = window.innerWidth
      })
    })
  },
  watch: {
    windowWidth () {
      console.log(`watch`)
      // console.log(this.windowWidth)
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/room/' + this.tokenroom)
      } else {
        this.$router.push('/chat/room/' + this.tokenroom)
      }
    }
  },
  methods: {
    get_user (tokenuser) {
      console.log(`getuser`)
      // console.log(tokenuser)
      this.$cookie.delete("tokenuser")
      this.$cookie.delete("status_login")
      // this.$cookie.delete("logouturl")
      localStorage.clear()
      this.progress = true
      var encodeAuth = Encode.encode({'tokenuser': tokenuser, 'status_login': 'T', 'type_user': 'user'})
      localStorage.setItem('Authenrization', encodeAuth)
      // console.log(`oneid: ${localStorage.getItem('oneid')}`)
      this.axios.post(process.env.APImanage + '/searchtokenuser', { tokenuser: tokenuser.replace(/['"]+/g, ''), tokenfriend: tokenuser.replace(/['"]+/g, '') }).then(response => {
        // console.log(response.data.user)
        if (response.data.status === 'success') {
          this.progress = false
          this.profile_infor = response.data.user
          // localStorage.setItem('Authenrization', encodeAuth)
          localStorage.setItem('profilepicture', this.profile_infor['profilepicture'])
          localStorage.setItem('name', this.profile_infor['name'])
          localStorage.setItem('phone', this.profile_infor['phone'])
          localStorage.setItem('email', this.profile_infor['email'])
          localStorage.setItem('status', this.profile_infor['status'])
          localStorage.setItem('type_user', this.profile_infor['type'])
          this.axios.get(process.env.APIgo_api + `/v1/getOneID/${tokenuser}`).then((response) => {
            if (response.data.status === 'success') {
              // console.log(this.one_id)
              localStorage.setItem('oneid', response.data.one_id)
              localStorage.setItem('tokenuser', Encode.encodeToken(tokenuser))
              // localStorage.setItem('Authenrization', Encode.encode({
              //   'tokenuser': this.profile_infor['tokenuser'],
              //   'status_login': 'T',
              //   'type_user': this.profile_infor['type'],
              //   'oneid': response.data.one_id
              // }))
            }
          })
          if (this.status_username === 'false') {
            localStorage.setItem('status_username', 'false')
          } else {
            localStorage.setItem('status_username', 'true')
          }
          // console.log(this.windowWidth)
          if (this.windowWidth <= 960) {
            this.$router.push('/mobile/room/' + this.tokenroom)
          } else {
            this.$router.push('/chat/room/' + this.tokenroom)
          }
        } else {
          this.progress = false
          this.$swal('', 'ขออภัยระบบไม่สามารถใช้งานได้ กรุณาลองใหม่อีกครั้งภายหลัง', 'warning')
        }
      }).catch(error => {
        this.progress = false
        this.$swal('', 'ขออภัยระบบไม่สามารถใช้งานได้ กรุณาลองใหม่อีกครั้งภายหลัง', 'warning')
        console.log(error)
      })
    },
    check_profile () {
      this.$swal({
        title: '',
        text: "คุณต้องการไปยังห้องแชทใช่หรือไม่?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
      }).then((result) => {
        if (result.value) {
          localStorage.setItem('Authenrization', Encode.encode({'tokenuser': this.profile_infor['tokenuser'], 'status_login': 'T', 'type_user': this.profile_infor['type']}))
          localStorage.setItem('profilepicture', this.profile_infor['profilepicture'])
          localStorage.setItem('name', this.profile_infor['name'])
          localStorage.setItem('phone', this.profile_infor['phone'])
          localStorage.setItem('email', this.profile_infor['email'])
          localStorage.setItem('status', this.profile_infor['status'])
          localStorage.setItem('type_user', this.profile_infor['type'])
          if (this.status_username === 'false') {
            localStorage.setItem('status_username', 'false')
          } else {
            localStorage.setItem('status_username', 'true')
          }
          if (this.windowWidth <= 960) {
            this.$router.push('/mobile/room/' + this.tokenroom)
          } else {
            this.$router.push('/chat/room/' + this.tokenroom)
          }
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
.img-user {
  border-style: solid;
  border-width: thin;
  border-color: #d2d2d2;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/RedirectService.vue